.page {
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  width: 100%;
  margin: 0 auto;
  padding: var(--space-6) calc(var(--page-gutter) + var(--safe-right)) var(--space-12)
    calc(var(--page-gutter) + var(--safe-left));
}

.default {
  max-width: calc(var(--content-max) + 2 * var(--page-gutter));
}

.narrow {
  max-width: calc(var(--content-narrow) + 2 * var(--page-gutter));
}

.header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-4);
}

.heading {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.eyebrow {
  margin-bottom: var(--space-1);
}

.title {
  font-family: var(--font-display);
  font-size: var(--text-3xl);
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-display);
  line-height: var(--leading-tight);
  overflow-wrap: anywhere;
}

.meta {
  color: var(--color-text-muted);
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--space-2);
}

@media (min-width: 1024px) {
  .page {
    padding-top: var(--space-10);
  }

  .title {
    font-size: var(--text-4xl);
  }
}
